//let host='https://mz-ei.gemeinde-entwickler.de/';
let host='https://website-backend.mz-ei.de/';

export default host